import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.ends-with.js";
import moment from 'moment';
import accounting from 'accounting';

require('moment/locale/sl.js');

export function formatDate(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD.MM.YYYY';

  if (value) {
    return moment(value).format(format);
  } else {
    return '';
  }
}
export function formatNumber(value, decimals) {
  if (value !== null) {
    return accounting.formatNumber(value, {
      precision: decimals,
      thousand: '.',
      decimal: ','
    });
  } else {
    return '';
  }
}
export function errorMap(array, key, option) {
  if (Array.isArray(array) && array.length > 0) {
    if (!option) {
      return array.filter(function (a) {
        return a.key === key;
      });
    } else if (option === 'startsWith') {
      return array.filter(function (a) {
        return a.key.startsWith(key);
      });
    } else if (option === 'endsWith') {
      return array.filter(function (a) {
        return a.key.endsWith(key);
      });
    }
  }

  return array;
}